import { useEffect } from "react";

const DownloadFrame = (props) => {


    useEffect(()=> {
        props.setNext(true)
    }, []);


    if(props.url.search(".pdf") == -1){
        return(
            <div>
                <div className="canvaFrame downloadFrame">
                    <a className="green-btn" href={props.url} target="_blank">Descargar Material</a>
                </div>
            </div>
        );
    }else{
        return(
            <div>
                <div className="canvaFrame downloadFrame">
                    <iframe src={props.url} className="canvaFrame cursadasIFrame"></iframe>
                </div>
            </div>
        );
    }
}

export default DownloadFrame;